import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-mf-control-unsaved-popup',
  templateUrl: './mf-control-unsaved-popup.component.html',
  styleUrls: ['./mf-control-unsaved-popup.component.css']
})
export class MfControlUnsavedPopupComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    
  }

  ngOnInit() {
  }

}
